export default __webpack_public_path__ + "static/media/hard_to_read.00f68cc7.svg";